/**
 * Look under your chair! console.log FOR EVERYONE!
 *
 * @see http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
 */
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());



/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var GLOBAL = {

  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      
      searchPlaceholder();


      $('.add-to-cart').on( 'click', addToCart );
    }
  },

  templateIndex : {
    init: function(){

    }
  },

  templateProduct : {
    init: function(){
      
    }
  },

  templateCart : {
    init: function(){
      
    }
  }

}



/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template{{ template | camelize }}" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

  fire : function(func,funcname, args){
    var namespace = GLOBAL;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },

  loadEvents : function(){
    var bodyId = document.body.id;

    // hit up common first.
    UTIL.fire('common');

    // do all the classes too.
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);



/**
 * Balance product grid height after all images have loaded.
 */
/*$(window).load( function(){
  if( $('body').hasClass('templateIndex') ){
    
  } else {
    
  }
});*/


/*
** Fly image to Cart
*/
function flyToCart(imgobj, cart, time){
  
  if(imgobj){
    var imgsrc = imgobj.attr('src');

    imgobj.animate_from_to(cart, {
      pixels_per_second: time, 
      initial_css: {
        'image': imgsrc
      },
      callback: function(){
      }
    });
  }
}


/**
 * Popup notify add-to-cart
 */
function notifyProduct($info, $life=5000){
  var wait = setTimeout(function(){
    $.jGrowl($info, { life: $life });
  },1000);
}


/**
 * Ajaxy add-to-cart
 */
function addToCart(e){

  if (typeof e !== 'undefined') e.preventDefault();

  var $this = $(this);
  $this.addClass('loading');
  
  var form = $this.parents('form');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: function(itm,msg,err) {
      
      $this.addClass('loaded');
      setTimeout(() => $this.removeClass('loading loaded'), 1400);
      
      /* If gift wrap button exists, and is selected, add Gift Wrapping to the cart */
      if ($("#jdh-giftwrap").length && $("#jdh-giftwrap").is(':checked')) {
        
        var giftWrapQty = form.find('[name="quantity"]').length ? form.find('[name="quantity"]').val() : 1;

//         giftWrapData = {
//           items: []
//         }
                
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: {
            quantity: giftWrapQty,
            id: 40670342054097,
            properties: {
              "For": $('#page-title').text(), //"{{ prod.title | replace: '&quot;', '"' | replace: '&amp;', '&' | replace: '&#039;', '\'' }}",
              "Gift Note": $("#jdh-giftwrap-msg").val()
            }
          },
          dataType: 'json',
          error: addToCartFail,
          success: function() {
            /* If there is a Gift Wrap message, also add it to the cart attributes */
            /* @@ Need to add support for multiple giftwrap messages @@ */
            if ($.trim($("#jdh-giftwrap-msg").val())) {
              $.ajax({
                type: 'POST',
                url: '/cart',
                async: false,
                data: {
                  attributes: {
                    "Gift_Wrap_Message": $("#jdh-giftwrap-msg").val()
                  }
                },
                dataType: 'json',
                error: (err) => console.log('Couldn\'t update Gift Wrap message:',err),
                success: () => {}
              });
            }
          },
          cache: false
        });
      }
      addToCartSuccess(itm,msg,err);
    },
    complete: setTimeout(() => {
      if (!$this.hasClass('loaded')) $this.removeClass('loading loaded');
  	}, 10),
    cache: false
  });
  
  /*
  if ($("#jdh-giftwrap").length && $("#jdh-giftwrap").is(':checked')) {
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: {
        quantity: giftWrapQty,
        id: 40670342054097,
        properties: {
          "For": $('#page-title').text(), //"{{ prod.title | replace: '&quot;', '"' | replace: '&amp;', '&' | replace: '&#039;', '\'' }}",
          "Gift Note": $("#nullsNote").val()
        }
      },
      dataType: 'json',
      error: addToCartFail,
      success: function() {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: form.serialize(),
          dataType: 'json',
          error: addToCartFail,
          success: addToCartSuccess,
          cache: false
        });
      },
      cache: false
    });
  }
  else {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: form.serialize(),
      dataType: 'json',
      error: addToCartFail,
      success: addToCartSuccess,
      cache: false
    });
  }
  */

  // Hide Modal
  $('.modal').modal('hide');
  
  // Fly image to Cart
  var parent = $this.parents($this.attr('data-parent'));
  var image = $(parent).prev().find('.image-fly');
  //--flyToCart(image, '#umbrella .cart-link', 700);
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){ 
  
  if ($('.add-to-cart').length) $('.add-to-cart').blur();
  
  if (!jqXHR['image'] || jqXHR['image'] == '') { /* If there is no product image, show the blank placeholder - JDH */
  	jqXHR['image'] = "//cdn.shopify.com/s/files/1/0550/6662/4209/t/2/assets/regions-blank.png?v=8685124714535106039";
  }
  
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });

  //-var $info = '<div class="row-fluid"><a href="'+ jqXHR['url'] +'" class="span3"><img style="max-width:64px; margin-left:-8px;" src="'+ Shopify.resizeImage(jqXHR['image'], "small") +'" alt="'+ jqXHR['title'] +'"/></a><div class="span9"><a class="jGrowl-title" href="'+ jqXHR['url'] +'">'+ (jqXHR['title'].length > 20 ? jqXHR['title'].slice(0,40) + "..." : jqXHR['title']) +'</a><div class="jGrowl-note"> added to cart</div></div></div>';
  var $newinfo = '<a href="/cart"><img style="max-width:64px; display: inline-block;vertical-align: top;margin-right: 8px;" src="'+ jqXHR['image'] +'" alt="'+ jqXHR['title'] +'" width="64" height="64"><div style="width: calc(100% - 72px);display: inline-block;"><h4>'+ (jqXHR['title'].length > 20 ? jqXHR['title'].slice(0,40) + "..." : jqXHR['title']) +'</h4> <span>added to your cart</span></div></a>'
  notifyProduct($newinfo); 
    
  // Let's get the cart and show what's in it in the cart box.	
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, 'cart-box');
    
    checkFreeShipping(cart, true); /* Located in api.jquery.custom.liquid */
  });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  
  var $info = '<div class="error">'+ response.description +'</div>';
  notifyProduct($info);
} 



/**
 * Enable placeholder switcheroo in older browsers.
 * @see http://webdesignerwall.com/tutorials/cross-browser-html5-placeholder-text
 */
function searchPlaceholder(){

  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
      })
    });
  }

}

/*&*/